import React, { useEffect, useState } from "react";
import axios from "axios";
import Resizer from "react-image-file-resizer";
import { toast } from "react-toastify";
import { Avatar, Badge } from "antd";
import "./Partnerapplyform.css";

// ปรับ URL นี้ให้ตรงกับ backend จริงของคุณ
const API_URL = process.env.REACT_APP_API || "https://www-test-360.uniquecarestationthailand.com/api";
// endpoint อัปโหลดรูปใช้ตัวเดียวกับที่ FileUpload.js เดิมใช้อยู่แล้ว (/images, /removeimages)
const UPLOAD_API = process.env.REACT_APP_API || API_URL;

const initialForm = {
  name: "",
  phone: "",
  email: "",
  organization: "",
};

const emptyProduct = () => ({
  _key: `p_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
  name: "",
  description: "",
  price: "",
  images: [],
});

// ===== ส่วนอัปโหลดรูปของสินค้าแต่ละรายการ (ดัดแปลงจาก FileUpload.js เดิม) =====
const ProductImageUpload = ({ images, onChange }) => {
  const [uploading, setUploading] = useState(false);

  const handleChangeFile = (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) {
      toast.error("ไม่พบไฟล์ที่เลือก");
      return;
    }

    setUploading(true);
    let uploaded = [...images];

    for (let i = 0; i < files.length; i++) {
      Resizer.imageFileResizer(
        files[i],
        600,
        600,
        "WEBP",
        100,
        0,
        (uri) => {
          axios
            .post(`${UPLOAD_API}/images/product-partner`, { image: uri })
            .then((res) => {
              uploaded = [...uploaded, res.data];
              onChange(uploaded);
              toast.success("อัปโหลดรูปสำเร็จ");
            })
            .catch((err) => {
              console.error(err);
              toast.error("อัปโหลดรูปไม่สำเร็จ");
            })
            .finally(() => setUploading(false));
        },
        "base64"
      );
    }
  };

  const handleRemove = (fileName, public_id) => {
    axios
      .post(`${UPLOAD_API}/removeimages/product-partner`, { fileName, public_id })
      .then(() => {
        const filtered = images.filter((item) => {
          if (fileName && item.fileName) return item.fileName !== fileName;
          if (public_id && item.public_id)
            return item.public_id !== public_id;
          return true;
        });
        onChange(filtered);
      })
      .catch((err) => {
        console.error(err);
        toast.error("ลบรูปไม่สำเร็จ");
      });
  };

  return (
    <div className="product-image-upload">
      <div className="product-image-list">
        {images.map((item) => (
          <span
            className="avatar-item"
            key={item.fileName || item.public_id}
          >
            <Badge
              onClick={() => handleRemove(item.fileName, item.public_id)}
              style={{ cursor: "pointer" }}
              count="x"
            >
              <Avatar
                src={item.url}
                alt="product"
                shape="square"
                size={64}
              />
            </Badge>
          </span>
        ))}
      </div>

      <label className="product-image-upload-btn">
        {uploading ? "กำลังอัปโหลด..." : "+ เพิ่มรูปสินค้า"}
        <input
          onChange={handleChangeFile}
          type="file"
          hidden
          multiple
          accept="image/*"
          disabled={uploading}
        />
      </label>
    </div>
  );
};

const PartnerApplyForm = ({ onSuccess }) => {
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState(null); // "success" | "error" | null

  const [categories, setCategories] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(true);
  const [selectedCategories, setSelectedCategories] = useState([]);

  const [products, setProducts] = useState([emptyProduct()]);

  // ดึงหมวดหมู่สินค้ามาให้เลือกตอนโหลดฟอร์ม
  useEffect(() => {
    const fetchCategories = async () => {
      setCategoriesLoading(true);
      try {
        const res = await fetch(
          `${API_URL}/product-category?type=category&isActive=true`
        );
        if (!res.ok) throw new Error();
        const data = await res.json();
        setCategories(data);
      } catch (err) {
        console.error(err);
        // ถ้าโหลดหมวดหมู่ไม่สำเร็จ ให้ปล่อยผ่านได้ ไม่บล็อกการสมัคร
      } finally {
        setCategoriesLoading(false);
      }
    };
    fetchCategories();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: null }));
    }
  };

  const toggleCategory = (id) => {
    setSelectedCategories((prev) =>
      prev.includes(id) ? prev.filter((c) => c !== id) : [...prev, id]
    );
  };

  const handleProductChange = (key, field, value) => {
    setProducts((prev) =>
      prev.map((p) => (p._key === key ? { ...p, [field]: value } : p))
    );
  };

  const handleProductImagesChange = (key, images) => {
    setProducts((prev) =>
      prev.map((p) => (p._key === key ? { ...p, images } : p))
    );
  };

  const addProductRow = () => {
    setProducts((prev) => [...prev, emptyProduct()]);
  };

  const removeProductRow = (key) => {
    setProducts((prev) =>
      prev.length === 1 ? prev : prev.filter((p) => p._key !== key)
    );
  };

  const validate = () => {
    const newErrors = {};

    if (!form.name.trim()) newErrors.name = "กรุณากรอกชื่อผู้ติดต่อ";

    if (!form.phone.trim()) {
      newErrors.phone = "กรุณากรอกเบอร์โทรศัพท์";
    } else if (!/^0[0-9]{8,9}$/.test(form.phone.trim())) {
      newErrors.phone = "รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง";
    }

    if (!form.email.trim()) {
      newErrors.email = "กรุณากรอกอีเมล";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) {
      newErrors.email = "รูปแบบอีเมลไม่ถูกต้อง";
    }

    if (!form.organization.trim())
      newErrors.organization = "กรุณากรอกชื่อองค์กร/บริษัท";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);

    if (!validate()) return;

    setSubmitting(true);
    try {
      // ตัดสินค้าที่ไม่ได้กรอกชื่อทิ้งก่อนส่ง
      const cleanProducts = products
        .filter((p) => p.name.trim())
        .map((p) => ({
          name: p.name.trim(),
          description: p.description,
          price: p.price ? Number(p.price) : undefined,
          images: p.images,
        }));

      const payload = {
        ...form,
        categories: selectedCategories,
        products: cleanProducts,
      };

      const res = await fetch(`${API_URL}/partner`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const errData = await res.json().catch(() => ({}));
        throw new Error(errData.error || "ส่งข้อมูลไม่สำเร็จ");
      }

      setStatus("success");
      setForm(initialForm);
      setSelectedCategories([]);
      setProducts([emptyProduct()]);
      if (onSuccess) {
        setTimeout(() => onSuccess(), 1500);
      }
    } catch (err) {
      console.error(err);
      setStatus("error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="partner-form-wrap" id="partner-apply-form">
      <h4 className="partner-form-title">สมัครเป็นพันธมิตรกับเรา</h4>
      <p className="partner-form-desc">
        กรอกข้อมูลด้านล่าง ทีมงานจะติดต่อกลับภายใน 3-5 วันทำการ
      </p>

      {status === "success" && (
        <div className="partner-form-alert success">
          ✅ ส่งใบสมัครสำเร็จ! ทีมงานจะติดต่อกลับโดยเร็วที่สุด
        </div>
      )}
      {status === "error" && (
        <div className="partner-form-alert error">
          ❌ เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง
        </div>
      )}

      <form className="partner-form" onSubmit={handleSubmit} noValidate>
        <div className="partner-form-group">
          <label htmlFor="name">ชื่อผู้ติดต่อ</label>
          <input
            id="name"
            name="name"
            type="text"
            placeholder="ชื่อ นามสกุล"
            value={form.name}
            onChange={handleChange}
            className={errors.name ? "error" : ""}
          />
          {errors.name && <span className="field-error">{errors.name}</span>}
        </div>

        <div className="partner-form-group">
          <label htmlFor="phone">เบอร์โทรศัพท์</label>
          <input
            id="phone"
            name="phone"
            type="tel"
            value={form.phone}
            onChange={handleChange}
            className={errors.phone ? "error" : ""}
          />
          {errors.phone && (
            <span className="field-error">{errors.phone}</span>
          )}
        </div>

        <div className="partner-form-group">
          <label htmlFor="email">อีเมล</label>
          <input
            id="email"
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            className={errors.email ? "error" : ""}
          />
          {errors.email && (
            <span className="field-error">{errors.email}</span>
          )}
        </div>

        <div className="partner-form-group">
          <label htmlFor="organization">ชื่อองค์กร/บริษัท</label>
          <input
            id="organization"
            name="organization"
            type="text"
            value={form.organization}
            onChange={handleChange}
            className={errors.organization ? "error" : ""}
          />
          {errors.organization && (
            <span className="field-error">{errors.organization}</span>
          )}
        </div>

        {/* ===== หมวดหมู่สินค้า ===== */}
        <div className="partner-form-group">
          <label>หมวดหมู่สินค้าที่สนใจนำมาขาย</label>
          {categoriesLoading && (
            <p className="hint-text">กำลังโหลดหมวดหมู่...</p>
          )}
          {!categoriesLoading && categories.length === 0 && (
            <p className="hint-text">ยังไม่มีหมวดหมู่ในระบบ</p>
          )}
          <div className="category-checkbox-list">
            {categories.map((cat) => (
              <label key={cat._id} className="category-checkbox-item">
                <input
                  type="checkbox"
                  checked={selectedCategories.includes(cat._id)}
                  onChange={() => toggleCategory(cat._id)}
                />
                {cat.name}
              </label>
            ))}
          </div>
        </div>

        {/* ===== รายการสินค้า ===== */}
        <div className="partner-form-group">
          <label>สินค้าที่ต้องการนำมาขาย</label>

          {products.map((product, idx) => (
            <div className="product-row" key={product._key}>
              <div className="product-row-header">
                <span>สินค้า #{idx + 1}</span>
                {products.length > 1 && (
                  <button
                    type="button"
                    className="product-remove-btn"
                    onClick={() => removeProductRow(product._key)}
                  >
                    ลบ
                  </button>
                )}
              </div>

              <input
                type="text"
                placeholder="ชื่อสินค้า"
                value={product.name}
                onChange={(e) =>
                  handleProductChange(product._key, "name", e.target.value)
                }
              />

              <textarea
                placeholder="รายละเอียดสินค้า"
                rows={2}
                value={product.description}
                onChange={(e) =>
                  handleProductChange(
                    product._key,
                    "description",
                    e.target.value
                  )
                }
              />

              <input
                type="number"
                placeholder="ราคาโดยประมาณ (บาท)"
                value={product.price}
                onChange={(e) =>
                  handleProductChange(product._key, "price", e.target.value)
                }
              />

              <ProductImageUpload
                images={product.images}
                onChange={(images) =>
                  handleProductImagesChange(product._key, images)
                }
              />
            </div>
          ))}

          <button
            type="button"
            className="add-product-btn"
            onClick={addProductRow}
          >
            + เพิ่มสินค้าอีกรายการ
          </button>
        </div>

        <button
          type="submit"
          className="btn-partner-apply"
          disabled={submitting}
        >
          {submitting ? "กำลังส่งข้อมูล..." : "สมัครเป็นพันธมิตรทันที ✦"}
        </button>
      </form>
    </div>
  );
};

export default PartnerApplyForm;